import { TooltipTrigger } from '@toggle/design-system';
import { CatalystInsight } from '@toggle/toggle';
import React, { useState } from 'react';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import { MarketCatalystCounterTooltip } from '~/views/dashboard/my-assets-widget/assets-table/insights-cell/market-catalyst-counter-tooltip/MarketCatalystCounterTooltip';
import { CatalystInsightIcon } from '~/widgets/catalyst-insights-drawer/catalyst-insight-icon/CatalystInsightIcon';

import styles from './ThemeKnowledgeGraph.module.scss';

const MAX_CATALYSTS = 3;

export interface ThemeCatalystsCellProps {
  catalystInsights: CatalystInsight[];
  source: PosthogTrackingSource;
}

export const ThemeCatalystsCell = ({
  catalystInsights,
  source,
}: ThemeCatalystsCellProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const visibleCatalysts = catalystInsights.slice(0, MAX_CATALYSTS);
  const remainingCatalysts = catalystInsights.slice(MAX_CATALYSTS);

  return (
    <div className={styles.catalystsWrapper}>
      {visibleCatalysts.map(insight => (
        <CatalystInsightIcon
          key={insight.id}
          customSize={{ width: 18, height: 20 }}
          enableHover
          catalystInsightId={insight.id}
          identifier={insight.identifier}
          subCategory={insight.sub_category}
          category={insight.category}
          source={source}
        />
      ))}
      {remainingCatalysts.length > 0 && (
        <TooltipContainer
          label={
            <MarketCatalystCounterTooltip
              insights={remainingCatalysts}
              source={source}
              onClose={() => setIsTooltipOpen(false)}
            />
          }
          inPortal
          trigger={[TooltipTrigger.Hover]}
          placement="top-end"
          withSafePolygon
          isOpen={isTooltipOpen}
          onOpen={() => setIsTooltipOpen(true)}
          onClose={() => setIsTooltipOpen(false)}
        >
          <span className={styles.moreCount}>+{remainingCatalysts.length}</span>
        </TooltipContainer>
      )}
    </div>
  );
};
